export const MERCHANT_CUSTOMER_ID_TIP =`
This is not Merchant ID (the legacy identifier prior to 2003). To find the equivalent Merchant Customer ID,<br/ > use <a href="https://isweb-gp.amazon.com/gp/paris/parisDataDumper.html">PARIS</a>. To learn more, see <a href="https://w.amazon.com/bin/view/SellingPartnerAuthorization/Public/MerchantID">wiki</a>.
`
